import React from 'react';
import { t } from 'Src/i18n';
import { PaymentButton } from 'Components/widgets/payment-button/PaymentButton';
import { PAYMENT_ACTION } from 'Utils/payment/constants';
type Props = {
  onClick?: () => void;
  stay: StayEntity;
  hasOptionServices?: boolean;
};
export const CartPaymentButton = ({ onClick, stay, hasOptionServices = false }: Props) => {
  const action: keyof typeof PAYMENT_ACTION = hasOptionServices
    ? 'PAYMENT_SERVICES_IN_OPTION'
    : 'PAYMENT_CART';
  return (
    <PaymentButton
      dataTestId="proceed-to-payment"
      errorLabel={t('stays.errors.paymentErrorDescription')}
      hasErrorNotification
      label={t('cart.proceedPayment')}
      onClick={onClick}
      action={action}
      bookingId={stay?.booking?.id}
      stayId={stay?.id}
    />
  );
};
